import systemStatuses from 'data/system_statuses';

const columns = [
  {
    name: 'Name',
    selector: (row) => row.attributes.full_name,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.attributes.email,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Invited On',
    selector: (row) => row.attributes.invited_on_timestamp,
    format: (row) => row.attributes.invited_on_formatted,
    sortable: true,
  },
  {
    name: 'Profile %',
    selector: (row) => row.attributes.fill_profile,
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    cell: (row) => systemStatuses.find((item) => item.value === row.attributes.status)?.label,
    sortable: true,
  },
  {
    name: 'Sessions',
    selector: (row) => row.attributes.sessions_count,
    sortable: true,
  },
];

export default columns;
